// @flow
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { RouteUtil } from 'utils/RouteUtil';
import CalendarContainer from 'components/molecules/Calendar';
import { DisplayTime } from 'components/atoms/displayTime';
import { groupBy, cloneDeep } from 'lodash';
import { DateUtil } from 'utils/DateUtil';
import { RouteNames } from 'router';
import { CountryTimeUtil } from 'utils/CountryTimeUtil';
import { CURRENT_COUNTRY_CODE } from 'config/env';
//eslint-disable-next-line
import styles from "./styles.scss";

const UpcomingEventsOverlay = props => {
  let { data } = props;
  const [eventsData, setEventsData] = useState(cloneDeep(data));
  const [dateRange, setDateRange] = useState([]);
  const countryCode = CURRENT_COUNTRY_CODE === '+1' ? 'USA' : 'INDIA';

  const groupData = key => {
    const validEventDates = CountryTimeUtil.filterValidEvents(eventsData, countryCode, false);
    let dateSort = validEventDates.sort(function(a, b) {
      return new Date(a.date) - new Date(b.date);
    });
    return groupBy(dateSort, key);
  };

  const [group, createGroup] = useState(groupData('desktopFullDate'));

  useEffect(() => {
    if (data) {
      setEventsData(cloneDeep(data));
      getEventsFromSelectedDates(dateRange);
    }
  }, [data]);

  useEffect(() => {
    createGroup(groupData('desktopFullDate'));
  }, [eventsData]);

  const getEventsFromSelectedDates = datesArray => {
    let temp_result = [];
    if (datesArray.length > 0) {
      datesArray.map(date => {
        data.map(event_data => {
          if (DateUtil.getIsSameDay(event_data.date, date)) {
            temp_result.push(event_data);
          }
        });
      });
    } else temp_result = data;
    return setEventsData(temp_result);
  };

  const onEventClick = urlSlug => {
    RouteUtil.setRouteChange(props, `${RouteNames.musicEvents}/${urlSlug}`);
  };

  return (
    <div className={'upcoming-events-overlay-container'}>
      <CalendarContainer
        events_data={data}
        dateRangeArray={datesArray => {
          setDateRange(datesArray);
          getEventsFromSelectedDates(datesArray);
        }}
      />
      <div className={'events-details-layout'}>
        {Object.keys(group).map(group_data => {
          const card_data = group[group_data];
          return (
            <div className={'upcoming-event-card-group'}>
              <div className={'group-info'}>
                <span className={'info-type'}>{group_data}</span>
              </div>
              {card_data.map(event_data => {
                return (
                  <div className={'event-details-body'}>
                    <div
                      className={'image-container'}
                      onClick={() => onEventClick(event_data.url_slug)}
                    >
                      <img src={event_data.image} alt={'Event-Image'} />
                    </div>
                    <div className={'info-row'}>
                      <div className={'event-name-container'}>
                        <h3
                          className={'event-name'}
                          onClick={() => onEventClick(event_data.url_slug)}
                        >
                          {event_data.name}
                        </h3>
                      </div>
                      <div className={'time-genre-container'}>
                        <DisplayTime
                          start_time={event_data.startTime}
                          end_time={event_data.endTime}
                        />
                        <h4 className={'genre'}>{event_data.genre}</h4>
                      </div>
                      <div className={'venue-location-container'}>
                        {event_data.venue && (
                          <h4 className={'venue'}>{event_data.venue}</h4>
                        )}
                        <h4 className={'event-city'}>{event_data.city}</h4>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default withRouter(UpcomingEventsOverlay);
